import spec from "../canvas/canvas-spec.json";
import { CONTACT_EMAIL, contactMailto } from "../lib/contact";

export function Footer() {
  return (
    <footer className="lp-footer">
      <p>
        © 2026 Orchestration Coach ·{" "}
        <a href={contactMailto()}>{CONTACT_EMAIL}</a>
        {" "}· <a href="#data-handling">Data handling</a>
        {" "}· <span className="lp-footer-version">Skill v{spec.skillVersion}</span>
      </p>
    </footer>
  );
}
